export function AdministrationPage() {
  return (
    <div>
      {/* TODO: Administration settings */}
    </div>
  );
}
